<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listMediumProtocol"
        title-table="Protocolo Meios"
        module="mediumProtocolSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_PROTOCOLO_MEIO_INSERIR"
        delete-permission="ROLE_PROTOCOLO_MEIO_DELETAR"
        view-permission="ROLE_PROTOCOLO_MEIO_CONSULTAR"
        edit-permission="ROLE_PROTOCOLO_MEIO_ATUALIZAR"
        @add="addNew"
        @edit="edit"
      />
      <FormMediumProtocol v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";

import FormMediumProtocol from "./forms/FormMediumProtocol.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormMediumProtocol,
  },
  computed: {
    ...mapState("mediumProtocolSettingsModule", {
      listMediumProtocol: (state) => state.listMediumProtocol,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("mediumProtocolSettingsModule/prepareToEdit", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
